import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "src/store/actions/action";
import { addCommas } from "src/utils/addCommas";
import { EstimateGoods } from "src/vo/estimateVo";
import styled from "styled-components";
import Box from "../common/Box";

interface propsData {
  freeYn?: string;
}

const CheckModalItem = (props: propsData) => {
  const estimateGoodsList: any = useAppSelector((state) => state.estimateReduce.estimate_goods_list);

  const [init, setInit] = useState({
    total_price: 0,
  });

  const { total_price } = init;

  const [freeYn, setFreeYn] = useState<string>();

  useEffect(() => {
    if (!isEmpty(props.freeYn)) {
      setFreeYn(props.freeYn);
    }
  }, [props]);

  useEffect(() => {
    let total = 0;
    if (estimateGoodsList) {
      for (let i = 0; i < estimateGoodsList.length; i++) {
        total += estimateGoodsList[i].total_price;
      }
    }
    setInit({
      ...init,
      total_price: total,
    });
  }, [estimateGoodsList]);

  return (
    <CheckInfo>
      <p>
        <strong>견적서를 등록하시겠습니까?</strong>
        <br />
        견적 수정은 본사 확인 전까지 가능합니다.
      </p>
      <Box pd="50px 15px 0">
        <p className="title">견적 내역</p>
        <CheckList>
          {estimateGoodsList.map((value: EstimateGoods, index: number) => {
            return (
              <>
                <li key={index}>
                  <p>{value.goods_name}</p>
                  <p>{addCommas(value.total_price)}</p>
                </li>
              </>
            );
          })}
        </CheckList>
        <SummaryConfirm>
          <p>총 견적금액{freeYn === "Y" && "(무상)"}</p>
          <p>
            <span>{freeYn === "Y" ? "0" : addCommas(total_price)}</span> 원
          </p>
        </SummaryConfirm>
      </Box>
    </CheckInfo>
  );
};

const CheckInfo = styled.div`
  > p {
    color: ${({ theme }) => theme.color.primary};
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    strong {
      font-weight: 700;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 500;
  }
`;

const CheckList = styled.ul`
  margin: 10px 0 15px;
  padding: 16px 0;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  > li {
    ${({ theme }) => theme.flexBox.flexMixin()}
    margin-top: 13px;
    font-weight: 500;
    &:first-child {
      margin-top: 0;
    }
    > p {
      &:last-child {
        font-family: "Poppins";
        font-weight: 500;
      }
    }
  }
`;

const SummaryConfirm = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  font-size: 18px;
  font-weight: 700;
  > p:last-child {
    color: ${({ theme }) => theme.color.main};
  }
`;

export default CheckModalItem;
